// Filename: public/BIEventsFunctions.js 
import { biLoggerFactory } from 'wix-private';
 
const msid = 'a6343bef-e52d-438e-bf02-5f3abad524a2'; //replace the value between quotes with your site msid value
 
/**
 * biGroupsLoggers it's an Object with key:value pair
 * key: represents src of the BI group
 * value: represents the biLogger function for that group
 * */
 
const biGroupsLoggers = {
    // src: biLoggerFactory(group, src, { msid }),
    19: biLoggerFactory('lp', 19, { msid }),
    80: biLoggerFactory('potential-experts', 80, { msid })
}
 
export async function fireBIEvent(src, evid, fields) {
 
    const biLogger = biGroupsLoggers[src];
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
        console.log('BI Event Fired Successfully with ', biEventObject);
    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}
